import React, { memo } from "react";
import { FaPencilAlt, FaCog, FaEye } from "react-icons/fa";
import { Dropdown } from "react-bootstrap";
import { FaTrashCan } from "react-icons/fa6";
import { useSelector } from "react-redux";
import { PiPrinterBold } from "react-icons/pi";
import { RiLockPasswordLine } from "react-icons/ri";
import { FaUser } from "react-icons/fa6";

const DropdownButton = ({
  canView,
  handleShowGlobalViewModal,
  handleEdit,
  handleDelete,
  handlePermission,
  canEdit,
  canDelete,
  item,
  canExport,
  handlePrint,
  handleShare,
  handelProfile,
  handleRefund,
  handleCancel,
}) => {
  const { tabIndex } = useSelector((state) => state.tableStatusChange);

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  return (
    <td
      style={{
        width: "100px",
        textAlign: "center",
        padding: "4px",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <Dropdown>
        <Dropdown.Toggle variant="success" className="light sharp i-false">
          {svg1}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {canView && handleShowGlobalViewModal && (
            <Dropdown.Item
              onClick={(e) => {
                handleShowGlobalViewModal && handleShowGlobalViewModal(item);
                e.stopPropagation();
              }}
            >
              <FaEye size={16} className="me-1 text-info" /> View
            </Dropdown.Item>
          )}
          {canEdit && handleEdit && tabIndex !== 3 && (
            <Dropdown.Item
              onClick={(e) => {
                handleEdit(item);
                e.stopPropagation();
              }}
            >
              <FaPencilAlt size={14} className="me-1 text-secondary" /> Edit
            </Dropdown.Item>
          )}
          {canDelete && handleDelete && (
            <Dropdown.Item
              onClick={(e) => {
                handleDelete(item);
                e.stopPropagation();
              }}
            >
              <FaTrashCan size={14} className="me-1 text-danger" /> Delete
            </Dropdown.Item>
          )}
          {canEdit && handlePermission && (
            <Dropdown.Item onClick={() => handlePermission(item)}>
              <FaCog size={14} className="me-1 text-primary" /> Permission
            </Dropdown.Item>
          )}
          {/* {canEdit && handlePermission && (
            <Dropdown.Item onClick={() => handlePermission(item)}>
              <FaCog size={14} className="me-1 text-primary" /> Permission
            </Dropdown.Item>
          )} */}
          {canExport && handlePrint && (
            <Dropdown.Item onClick={() => handlePrint(item)}>
              <PiPrinterBold size={16} className="me-1 text-primary" /> Print
            </Dropdown.Item>
          )}

          {handleShare && (
            <Dropdown.Item onClick={() => handleShare(item)}>
              <RiLockPasswordLine size={14} className="me-1 text-warning" />{" "}
              Share
            </Dropdown.Item>
          )}
          {handelProfile && (
            <Dropdown.Item onClick={() => handelProfile(item)}>
              <FaUser size={14} className="me-1 text-primary" />
              Profile
            </Dropdown.Item>
          )}
          {handleRefund && item?.status === "PAID" && (
            <Dropdown.Item onClick={() => handleRefund(item)}>
              <FaUser size={14} className="me-1 text-primary" />
              Refund
            </Dropdown.Item>
          )}
          {handleCancel && (
            <Dropdown.Item onClick={() => handleCancel(item)}>
              <FaUser size={14} className="me-1 text-primary" />
              Cancel
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </td>
  );
};

export default memo(DropdownButton);
